const PayoneerIcon = /*#__PURE__*/ [
  ["circle", { cx: "11.9999", cy: "12", r: "9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { PayoneerIcon as default };
//# sourceMappingURL=PayoneerIcon.js.map
